import { APP_JSON } from '../../constants/common-enums';
import fetchReq from '../../helpers/fetch';
import { systemCorrelationId } from '../../helpers/gen-static-id';
import getBrowserName from '../../helpers/get-browser-name';
import scrubLogs from '../../helpers/scrub-logs';
import splunkLoggingSingleton from '../../helpers/splunk-logging-singleton';
import CONFIG from '../../settings';

const API = {
  /**
   * Event logging api
   *  - takes request payload
   *  - returns empty response body
   *  - Fired as part of init, isRecognized, getSrcProfile
   * @param {string} requestObject
   * @param {string} correlationId
   * @returns {object} response object
   */
  eventLogging(requestObject, correlationId) {
    // Skip splunk logging when running in cypress
    if (splunkLoggingSingleton.isCypressMode === true) {
      return undefined;
    }

    const loggingData = {
      Browser: getBrowserName(),
      CO: 'ORCHJSSDK',
      CR: correlationId,
      E: 'visa_srci',
      LL: 'INFO',
      O: 'JSSDK',
      OS: navigator.platform,
      RTY: 'OUT',
      T: 'E',
      ...scrubLogs(requestObject)
    };
    const options = {
      body: loggingData,
      headers: {
        Accept: APP_JSON,
        'Content-Type': APP_JSON,
        'X-CORRELATION-ID': correlationId || systemCorrelationId
      },
      method: 'POST',
      url: CONFIG.application.api.eventLogging
    };

    return fetchReq(options);
  }
};

export default API;
